import type { SVGProps } from 'react';
import { INTEGRATION_BRANDS } from '@/lib/brand/integration-brands';

// ShipStation official boxed symbol - ticket shape with hexagonal center
const ShipStation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={INTEGRATION_BRANDS.shipstation.primary}
      d="M455.22,455.22V44.78H44.78v410.44h410.44Z"
    />
    <path
      fill={INTEGRATION_BRANDS.shipstation.palette?.ink}
      d="M390.32,228.49c-20.22,0-36.61-16.39-36.61-36.62,0-10.11,4.1-19.26,10.72-25.88l-30.41-30.42c-6.62,6.62-15.77,10.72-25.88,10.72-20.22,0-36.61-16.39-36.61-36.62h-21.51-21.51c0,20.23-16.39,36.62-36.61,36.62-10.11,0-19.26-4.1-25.88-10.72l-30.41,30.42c6.62,6.63,10.72,15.78,10.72,25.88,0,20.22-16.39,36.62-36.61,36.62v43.02c20.22,0,36.61,16.39,36.61,36.62,0,10.11-4.1,19.26-10.72,25.88l30.41,30.42c6.62-6.62,15.77-10.72,25.88-10.72,20.22,0,36.61,16.39,36.61,36.62h21.51 21.51c0-20.23,16.39-36.62,36.61-36.62,10.11,0,19.26,4.1,25.88,10.72l30.41-30.42c-6.62-6.63-10.72-15.78-10.72-25.88,0-20.22,16.39-36.62,36.61-36.62v-43.02ZM320.48,290.69l-70.48,40.69-70.48-40.69v-81.38l70.48-40.69,70.48,40.69v81.38Z"
    />
  </svg>
);

export { ShipStation };
